var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRadio = function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 5.889H0A7.715 7.715 0 0 1 3.2 0h26.61s.01 0 .01.01A7.736 7.736 0 0 1 33 5.89Z",
    fill: "#BC0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.485 2.94c-.173 4.118 1.1 14.97 1.1 14.97.592 5.401-2.618 7.72-6.053 7.72 0 0-2.69-.05-3.496.285C18.243 26.688 17.57 28 16.561 28H16.46c-1.009 0-1.681-1.312-3.475-2.085-.805-.346-3.496-.285-3.496-.285-3.434 0-6.634-2.308-6.054-7.72 0 0 1.285-10.852 1.101-14.97C4.413.345 3.72.07 3.261.01V0H29.74v.01c-.459.061-1.142.336-1.254 2.93Z",
    fill: "#F21D19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 27.522c-.357 0-.714-.295-1.203-.702-.52-.427-1.162-.956-2.09-1.353-.642-.274-2.13-.335-3.271-.335h-.418c-1.722 0-3.22-.61-4.21-1.72-1.13-1.26-1.6-3.152-1.355-5.46.051-.438 1.285-10.934 1.111-15.043-.05-1.089-.193-1.892-.448-2.441h23.899c-.265.549-.408 1.352-.448 2.44-.174 4.11 1.05 14.606 1.11 15.043.255 2.309-.214 4.2-1.355 5.462-.999 1.108-2.497 1.719-4.21 1.719h-.417c-1.141 0-2.64.06-3.271.335-.928.397-1.57.926-2.09 1.353-.489.407-.846.702-1.202.702h-.132Z",
    fill: "url(#radio_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.131 11.249c0 .046-.05.126-.15.241-.1.115-.208.251-.323.408a4.538 4.538 0 0 0-.323.511 1.132 1.132 0 0 0 0 1.126 3.88 3.88 0 0 0 .646.857c.1.097.15.159.15.186v1.451c0 .157-.06.334-.179.532-.12.198-.268.385-.445.56a2.53 2.53 0 0 1-.588.435 1.298 1.298 0 0 1-.61.173h-7.13a1.87 1.87 0 0 1-.711-.132 1.77 1.77 0 0 1-.567-.366 1.677 1.677 0 0 1-.38-.553 1.734 1.734 0 0 1-.136-.69v-5.955c0-.185.043-.376.129-.574a1.87 1.87 0 0 1 .366-.545c.158-.166.344-.304.56-.415.215-.11.451-.166.71-.166h7.13c.259 0 .5.044.725.132.225.087.421.207.588.359a1.64 1.64 0 0 1 .538 1.223v1.202Zm4.463-1.3v6.315a.914.914 0 0 1-.165.539c-.11.156-.275.235-.495.235a.743.743 0 0 1-.294-.083c-.12-.055-.24-.12-.36-.194a6.906 6.906 0 0 1-.336-.22 2.019 2.019 0 0 1-.23-.18 9.403 9.403 0 0 1-.567-.525c-.253-.249-.509-.53-.767-.843a7.615 7.615 0 0 1-.682-.967c-.196-.332-.294-.636-.294-.912 0-.277.105-.592.316-.947.21-.354.464-.702.76-1.043.297-.34.608-.656.933-.946.325-.29.598-.51.818-.657.086-.055.203-.122.351-.2a.867.867 0 0 1 .395-.117c.258 0 .425.069.502.207.076.138.115.309.115.511v.028Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "radio_svg__a",
    x1: 16.502,
    y1: -6.155,
    x2: 16.502,
    y2: 6.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgRadio;